import React, { useEffect, useState } from 'react';
import './Toaster.css';

const Toaster = () => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const handleNotification = (event) => {
      const { message, type = 'info' } = event.detail;
      const id = Date.now();
      setNotifications(prev => [...prev, { id, message, type }]);

      // Remove notification after 3 seconds
      setTimeout(() => {
        setNotifications(prev => prev.filter(notification => notification.id !== id));
      }, 3000);
    };

    window.addEventListener('showNotification', handleNotification);
    return () => window.removeEventListener('showNotification', handleNotification);
  }, []);

  return (
    <div className="toaster-container">
      {notifications.map(notification => (
        <div key={notification.id} className={`toast ${notification.type}`}>
          {notification.message}
        </div>
      ))}
    </div>
  );
};

export default Toaster; 